const BulkActionModule = 'bulkAction';
const CustomerModule = 'customer';
const CampaignModule = 'campaign';
const PageHeaderModule = 'pageHeader';
const RuleModule = 'rule';
const RewardModule = 'reward';
const GlobalModule = 'global';

export {
  BulkActionModule,
  CustomerModule,
  CampaignModule,
  PageHeaderModule,
  RuleModule,
  RewardModule,
  GlobalModule
};
